import { isApiError } from "@bw/shared/api";
import { partyFullMessage } from "./mapInviteError";

export function mapRespondPartyInviteError(err: unknown, accept: boolean): string {
  if (isApiError(err)) {
    if (err.code === "NO_ACTIVE_DROP_IN") {
      return accept
        ? "Check in at this facility before accepting this invite."
        : "We couldn't decline that invite. Please try again.";
    }
    if (err.code === "INVITE_EXPIRED") {
      return "This invite has expired.";
    }
    if (err.code === "ALREADY_IN_PARTY") {
      return "You're already in another party at this facility.";
    }
    if (err.code === "PARTY_FULL") {
      return partyFullMessage(err.details);
    }
    if (err.code === "PARTY_NOT_OPEN") {
      return "This party is no longer accepting players.";
    }
    if (err.code === "INVITE_ALREADY_RESPONDED") {
      return "This invite has already been handled.";
    }
    if (err.status === 403) {
      return "You can't respond to this invite.";
    }
  }
  return "We couldn't update that invite. Please try again.";
}
